import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

import { CompanyLogo } from "app/pages/sales-intelligence/common-components/CompanyLogo/CompanyLogo";
import { aiAgentColors } from "app/pages/sales-intelligence/modules/ai-agent/components";
import type { ChatMessageVariant } from "app/pages/sales-intelligence/modules/ai-agent/components/ChatMessage/types";
import type { AgentChatThemeValue } from "app/pages/sales-intelligence/modules/ai-agent/components/MessagesList/styles";

export const StyledMessage = styled.div<{ variant: ChatMessageVariant; theme: AgentChatThemeValue }>`
    ${setFontVariant("body2", colorsPalettes.carbon[500])};

    display: flex;
    align-items: ${({ variant }) => (variant === "ai" ? "flex-start" : "center")};
    align-self: ${({ variant }) => (variant === "ai" ? "flex-start" : "flex-end")};
    flex-direction: ${({ variant }) => (variant === "ai" ? "column" : "row")};

    padding: ${({ theme: { msgPadding }, variant }) =>
        typeof msgPadding === "string" ? msgPadding : msgPadding[variant]};
    max-width: ${({ theme: { msgMaxWidth }, variant }) =>
        typeof msgMaxWidth === "string" ? msgMaxWidth : msgMaxWidth[variant]};

    background-color: ${({ variant }) => (variant === "ai" ? "transparent" : aiAgentColors.lightBlue)};
    border-radius: ${({ theme }) => theme.msgBorderRadius};

    box-sizing: border-box;
    overflow-wrap: anywhere;
    ${({ variant }) =>
        variant === "human" &&
        css`
            white-space: pre-wrap;
        `}

    ul {
        padding: 0;
    }
`;

export const StyledCompanyLogo = styled(CompanyLogo)`
    margin: 0 8px;
    display: inline-flex;
`;

export const StyledIconButton = styled(IconButton)`
    ${({ isDisabled }) =>
        isDisabled &&
        css`
            cursor: not-allowed;
            pointer-events: auto;
            &:hover {
                background-color: transparent;
                color: ${colorsPalettes.carbon[200]} !important;
                & div {
                    color: ${colorsPalettes.carbon[200]} !important;
                }
                & svg path {
                    fill: ${colorsPalettes.carbon[200]} !important;
                }
            }
        `}
`;
